import { template as _$template } from "solid-js/web";
import { className as _$className } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
const _tmpl$ = /*#__PURE__*/_$template(`<div class="group/tooltip relative block"><div role="tooltip">`);
export default function Tooltip(props) {
  const positionMap = {
    bottom: "-bottom-7 left-1/2 -translate-x-1/2 transform",
    left: "-left-2 top-1/2 -translate-y-1/2 -translate-x-full transform",
    right: "-right-2 top-1/2 -translate-y-1/2 translate-x-full transform",
    top: "-top-7 left-1/2 -translate-x-1/2 transform"
  };
  return (() => {
    const _el$ = _tmpl$(),
      _el$2 = _el$.firstChild;
    _$insert(_el$, () => props.children, _el$2);
    _$insert(_el$2, () => props.tooltipText);
    _$effect(() => _$className(_el$2, "pointer-events-none invisible absolute z-10 whitespace-nowrap rounded bg-gray-700 px-2 py-1 text-center text-xs text-white opacity-0 transition-opacity duration-300 group-hover/tooltip:visible group-hover/tooltip:opacity-100" + " " + positionMap[props.position || "top"]));
    return _el$;
  })();
}